import type { Strapi5Error } from '@nuxtjs/strapi'

export default defineNuxtPlugin((nuxt) => {
  nuxt.hook('strapi:error' as any, (e: Strapi5Error) => {
    const logger = useFrontendLogger()
    if (e.error?.name !== 'ValidationError') {
      logger.error(e)
    }
  })
})